import { render, staticRenderFns } from "./ActiveTrainingMiniature.vue?vue&type=template&id=48828f96&"
import script from "./ActiveTrainingMiniature.vue?vue&type=script&lang=js&"
export * from "./ActiveTrainingMiniature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports